import { useMutation } from "react-query"
import * as api from '../api'
import { Params } from "../commonTypes"

export const usePayMutation = () => {
    return useMutation((params: Params.Pay) => api.pay(params))
}